"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDialog = exports.Dialog = void 0;
var morse_react_1 = require("morse-react");
var react_1 = __importDefault(require("react"));
var Dialog = function (props) {
    var _a;
    var buttons = props.buttons, title = props.title, titleProps = props.titleProps, icon = props.icon, closeIcon = props.closeIcon, closeText = props.closeText, onClosed = props.onDismissed, children = props.children, allowDismiss = props.allowDismiss, className = props.className, panelProps = __rest(props, ["buttons", "title", "titleProps", "icon", "closeIcon", "closeText", "onDismissed", "children", "allowDismiss", "className"]);
    var close = function () {
        if (onClosed) {
            onClosed();
        }
    };
    return (react_1.default.createElement(morse_react_1.Panel, __assign({ panelOrigin: morse_react_1.Position.MiddleCenter, withDimming: true, isOpen: true, preventDismissByEsc: !allowDismiss }, panelProps, { preventDismissByClickAway: true, onRequestClose: close }),
        react_1.default.createElement("div", { className: "c-dialog " + (className !== null && className !== void 0 ? className : "") },
            react_1.default.createElement("div", { className: "c-dialog__head" },
                react_1.default.createElement("span", { className: "c-dialog__icon c-icon" }, typeof icon === "string" ? react_1.default.createElement("img", { src: icon }) : icon),
                react_1.default.createElement(morse_react_1.Heading
                // Default level is H2, but can be overridden in `titleProps`
                , __assign({}, __assign({ level: morse_react_1.Heading.Level.H2 }, titleProps), { className: ("c-dialog__heading " + ((_a = titleProps === null || titleProps === void 0 ? void 0 : titleProps.className) !== null && _a !== void 0 ? _a : "")).trimEnd() }), title),
                allowDismiss && (react_1.default.createElement("button", { className: "c-dialog__close", onClick: close }, closeIcon ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(morse_react_1.Icon, { className: "c-dialog__close-icon", iconName: closeIcon }),
                    closeText && (react_1.default.createElement("span", { className: "c-dialog__close-text" }, closeText)))) : (react_1.default.createElement("svg", { height: "21", viewBox: "0 0 21 21", width: "21", xmlns: "http://www.w3.org/2000/svg" },
                    react_1.default.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "#2a2e3b", strokeLinecap: "round", strokeLinejoin: "round", transform: "translate(5 5)" },
                        react_1.default.createElement("path", { d: "m.5 10.5 10-10" }),
                        react_1.default.createElement("path", { d: "m10.5 10.5-10-10z" }))))))),
            react_1.default.createElement("div", { className: "c-dialog__body" }, children),
            react_1.default.createElement("div", { className: "c-dialog__foot" },
                react_1.default.createElement("div", { className: "c-button-bar" }, buttons)))));
};
exports.Dialog = Dialog;
var useDialog = function () {
    var dialogContext = morse_react_1.usePortal(morse_react_1.PortalContext);
    var shownDialog;
    return {
        show: function (dialog) {
            shownDialog = dialogContext.openPortal(dialog);
        },
        close: function () {
            dialogContext.closePortal(shownDialog);
        },
    };
};
exports.useDialog = useDialog;
//# sourceMappingURL=Dialog.js.map